module.exports = __webpack_public_path__ + "static/media/warning-2.92366135.svg";